import { render, staticRenderFns } from "./ProjectUpdateBanner.vue?vue&type=template&id=1e872c44"
import script from "./ProjectUpdateBanner.vue?vue&type=script&lang=js"
export * from "./ProjectUpdateBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports